/* import __COLOCATED_TEMPLATE__ from './loading-indicator.hbs'; */
import Component from '@ember/component';

const CLASS_NAME = 'SH-c-loading-indicator';

export default Component.extend({
  tagName: '',
  CLASS_NAME,

  /** @param {String} */
  class: '',
});
